import { render, staticRenderFns } from "./TheJournalsView.vue?vue&type=template&id=36130dfc&"
import script from "./TheJournalsView.vue?vue&type=script&lang=js&"
export * from "./TheJournalsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports